import { useEffect, useContext, useCallback, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';
import Grid from '@mui/joy/Grid';
import Stack from '@mui/joy/Stack';
import Button from '@mui/joy/Button';

import MessagesPane from './MessagesPane';

import { RecentsContext } from '../contexts/recents_context';
import CollabWorkSpaceSidebar from './CollabWorkSpaceSidebar'
import LoadingScreenBig from './LoadingScreenBig';

import useUserIdentity from 'hooks/useUserIdentity';
import useCollabs from 'hooks/useCollabs';
// import CollabWorkSpaceCollabInfo from 'components/CollabWorkSpaceCollabInfo';
import { ChatBubbleSmall } from 'components/ChatBubble';
import getIcon from 'utils/getIcon';

const CollabWorkSpace = observer(({ collabKey }: { collabKey: string }) => {
    const { currentCollab, fetchCollab, collabByKey, collabs } = useCollabs();
    const { addRecent } = useContext(RecentsContext);
    const [addedRecent, weAddedRecent] = useState(false);
    const [collab, setCurrentCollab] = useState(currentCollab);
    const { currentIdentity } = useUserIdentity();

    const navigate = useNavigate();
    const InfoOutlined = getIcon('InfoOutlined');

    useEffect(() => {
        const c = collabByKey(collabKey);
        setCurrentCollab(c);
        document.title = collab?.title || "Collab Overview";
    }, [collabKey, collabByKey, collabs.length]);

    const callback = useCallback(() => {
        if(currentIdentity?.key) {
            fetchCollab(currentIdentity.key, collabKey);
        }
    }, [collabKey, fetchCollab, currentIdentity.key]);

    useEffect(() => {
        callback();
    }, [callback]);

    const doAddRecent = useCallback(() => {
        if(addRecent) {
            addRecent({type: 'collab', 'key': collabKey});
        }
    }, [addRecent, collabKey]);

    useEffect(() => {
        if(!addedRecent) {
            weAddedRecent(true);
            doAddRecent();
        }
    }, [doAddRecent, addedRecent, weAddedRecent]);

    if(!collab) {
        return <LoadingScreenBig />;
    }
    else {

    return (
        <Stack>
            <Grid container
                sx={{
                    m: 0,
                    p: 0,
                }}>

                <Grid xs={12} sm={8} md={8}>
                    <Stack pt={1}>
                        <Stack
                            sx={{
                                display: { xs: "block", sm: "none" }
                            }}
                        >
                            <Stack
                                direction="row"
                                justifyContent="flex-end"
                            >
                                <Button
                                    endDecorator={<InfoOutlined />}
                                    onClick={() => navigate(`/collab/${collab.key}/sidebar`)}
                                    variant="plain"
                                >Show Info</Button>
                            </Stack>
                        </Stack>

                        <Stack mb={2}>

                        <ChatBubbleSmall
                            content={collab.description}
                            content_type="text/plain"
                            date_created={collab.date_created}
                            identityKey={collab.identity}
                        />
                        </Stack>

                        <MessagesPane
                            bubbleSize="small"
                            associated_uuid={collab.uuid}
                            associated_type="collab"
                            collab={collab} />
                    </Stack>
                </Grid>

            <Grid xs={12} sm={4} md={4}
                sx={{
                    // position: "sticky",
                    zIndex: 800,
                    top: 'var(--TopperHeight)',
                    right: "0px",
                    flexGrow: 1,
                    //        borderLeft: { xs: "none", sm: "solid 1px #ccc" },
                }}
                justifyContent="flex-start"
            >
                <Stack

                sx={{
                    zIndex: 850,
                    //backgroundColor: theme.vars.palette.background.surface,
                    overflow: 'auto',
                    position: { xs: undefined, sm: 'sticky' },
                    top: { xs: undefined, sm: `var(--TopperHeight)` },
                }}
                >
                    <Stack pt={1} sx={{ display: { xs: 'none', sm: 'flex' }}}>
                        <CollabWorkSpaceSidebar collab={collab} />
                    </Stack>

                </Stack>
            </Grid>
        </Grid>
        </Stack>
    );
    }
});

export default CollabWorkSpace;
